import { createSlice } from '@reduxjs/toolkit';

// settingsSlice tanımı
const settingsSlice = createSlice({
  name: 'settings',
  initialState: {
    email: '',
    notification: 'enabled',
    language: 'tr',
    status: 'idle', // 'idle' | 'loading' | 'succeeded' | 'failed'
    error: null,
  },
  reducers: {
    setSettings(state, action) {
      return { ...state, ...action.payload };
    }
  },

});

export const { setSettings } = settingsSlice.actions;
export default settingsSlice.reducer;
